import { Coordinate, Coordinates, Highlight } from './BaseDocuments'
import { LABELS as labelsInvoiceV2 } from './DocumentsInvoiceBase'
import {
  DocumentInvoiceV2JSON,
  BASE_SECTIONS as BASE_SECTIONS_INVOICE_V2,
} from './DocumentsInvoiceV2.ts'
import {
  DocumentOrderFormJSON,
  BASE_SECTIONS as BASE_SECTIONS_ORDER_FORM,
  LABELS as labelsOrderForm,
} from './DocumentsOrderForm'

export interface OcrRespItem {
  confindenceScore: number
  boundingBoxes?: BoundingBox[]
  text: string
  keyText: string
  formatted?:
    | { year: string; month: string; day: string }
    | { value: number | string }
  taxRate?: number | null
  detectedPage: number
}

interface BoundingBox {
  0: Coordinate // eslint-disable-line @typescript-eslint/naming-convention
  1: Coordinate // eslint-disable-line @typescript-eslint/naming-convention
  2: Coordinate // eslint-disable-line @typescript-eslint/naming-convention
  3: Coordinate // eslint-disable-line @typescript-eslint/naming-convention
}

export function boundingBoxes2Coordinates(
  boundingBoxes: BoundingBox[],
): Coordinates[] {
  return boundingBoxes.map(
    (box, _index) =>
      ({
        /* eslint-disable @typescript-eslint/naming-convention */
        top_left: box[0],
        top_right: box[1],
        bottom_right: box[2],
        bottom_left: box[3],
        /* eslint-enable */
      }) as Coordinates,
  )
}

export function getHighlights(
  BASE_SECTIONS:
    | typeof BASE_SECTIONS_ORDER_FORM
    | typeof BASE_SECTIONS_INVOICE_V2,
  labels: typeof labelsOrderForm | typeof labelsInvoiceV2,
  { config, ocrResp }: DocumentOrderFormJSON | DocumentInvoiceV2JSON,
) {
  const highlights: Highlight[] = []

  BASE_SECTIONS.forEach((section) => {
    const fields = ocrResp[section]
    if (!fields) {
      return
    }

    Object.keys(fields).forEach((name) => {
      const field = fields[name]

      if (
        !config[section]?.[name]?.display ||
        !field?.confidenceScore ||
        !Array.isArray(field.boundingBoxes)
      ) {
        return
      }

      boundingBoxes2Coordinates(field.boundingBoxes).forEach((c, i) =>
        highlights.push({
          name: `${section}.${name}.${i}`,
          label: labels[section][name],
          detectedPage: field.detectedPage || 0,
          coordinates: c,
        }),
      )
    })
  })

  ocrResp.itemLines?.forEach((fields) => {
    Object.keys(fields).forEach((name) => {
      const field = fields[name]

      if (
        !config.itemLines?.[name]?.display ||
        !field?.confidenceScore ||
        !Array.isArray(field.boundingBoxes)
      ) {
        return
      }

      boundingBoxes2Coordinates(field.boundingBoxes).forEach((c, i) =>
        highlights.push({
          name: `${fields.id}.${name}.${i}`,
          label: labels['itemLines'][name],
          detectedPage: field.detectedPage || 0,
          coordinates: c,
        }),
      )
    })
  })

  return highlights
}
